import React from 'react';
interface ContentSectionProps {
  id: string;
  title: string;
  text: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  reversed?: boolean;
  bgColor?: string;
}
export function ContentSection({
  id,
  title,
  text,
  imageSrc,
  imageAlt,
  reversed = false,
  bgColor = 'bg-white'
}: ContentSectionProps) {
  return <section id={id} className={`py-24 ${bgColor}`} data-id="element-13">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className={`flex flex-col md:flex-row items-center gap-12 lg:gap-20 ${reversed ? 'md:flex-row-reverse' : ''}`} data-id="element-15">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-16">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a1a1a] mb-6" data-id="element-17">
              {title}
            </h2>
            <div className="text-xl text-gray-700 leading-relaxed" data-id="element-18">{text}</div>
          </div>

          {/* Circular Image Content */}
          <div className="flex-1 w-full flex justify-center" data-id="element-19">
            {imageSrc ? <div className="relative" data-id="element-20">
                {/* Shadow/glow effect */}
                <div className="absolute inset-0 rounded-full bg-[#1e5631]/10 blur-2xl scale-110" data-id="element-21"></div>
                {/* Image container */}
                <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full overflow-hidden shadow-2xl ring-4 ring-white" data-id="element-22">
                  <img src={imageSrc} alt={imageAlt || title} className="w-full h-full object-cover" data-id="element-23" />
                </div>
              </div> : <div className="relative" data-id="element-24">
                <div className="absolute inset-0 rounded-full bg-gray-200 blur-2xl scale-110" data-id="element-25"></div>
                <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full bg-gray-100 flex items-center justify-center shadow-xl ring-4 ring-white" data-id="element-26">
                  <span className="text-gray-400 font-medium" data-id="element-27">Image</span>
                </div>
              </div>}
          </div>
        </div>
      </div>
    </section>;
}